import { render, staticRenderFns } from "./tagsView.vue?vue&type=template&id=49268744&scoped=true"
import script from "./tagsView.vue?vue&type=script&lang=js"
export * from "./tagsView.vue?vue&type=script&lang=js"
import style0 from "./tagsView.vue?vue&type=style&index=0&id=49268744&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49268744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49268744')) {
      api.createRecord('49268744', component.options)
    } else {
      api.reload('49268744', component.options)
    }
    module.hot.accept("./tagsView.vue?vue&type=template&id=49268744&scoped=true", function () {
      api.rerender('49268744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newMenu/tagsView.vue"
export default component.exports